module.exports = __webpack_public_path__ + "static/resources-latest-snapshot-c2bf24dc60efd9d989f3b1728cc69477.png";